// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.90.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.90.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SSIEmailVerificationPage_contentContainer__pi2VA {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 80%;
    position: relative;
    min-height: 600px;
}

.SSIEmailVerificationPage_captionContainer__40XfX {
    display: flex;
    flex-direction: column;
    text-align: center;
    gap: 8px;
    position: absolute;
    top: 25%;
    width: 100%;
    min-height: 150px;
}

.SSIEmailVerificationPage_bottomWrapper__61WBZ {
    justify-content: center;
    margin-top: auto;
    margin-bottom: calc(160px - 4vh);
    display: flex;
    flex-direction: column;
    align-items: center;
}

.SSIEmailVerificationPage_verificationContainer__sgGPG {
    display: flex;
    flex-direction: column;
    text-align: center;
    gap: 8px;
    margin-bottom: 60px;
}

/* For smaller screens */
@media (max-height: 800px) {
    .SSIEmailVerificationPage_bottomWrapper__61WBZ {
        margin-bottom: calc(100px - 2vh);
    }
    .SSIEmailVerificationPage_captionContainer__40XfX {
        top: 15%;  /* Bring it a bit higher */
    }
}


.SSIEmailVerificationPage_mainTitle__kZU3C {
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 32px;
}

.SSIEmailVerificationPage_subTitle__O8ma7 {
    color: #424242;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
}

.SSIEmailVerificationPage_spacer__vpHZT {
    height: 10px;
}

.SSIEmailVerificationPage_description__7Yg4b {
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
}

.SSIEmailVerificationPage_rightPanel__\\+0Y7i {
    display: flex;
    flex-grow: 1;
    align-items: center;
    flex-direction: column;
}

`, "",{"version":3,"sources":["webpack://./src/pages/SSIEmailVerificationPage/index.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;AACvB;;AAEA,wBAAwB;AACxB;IACI;QACI,gCAAgC;IACpC;IACA;QACI,QAAQ,GAAG,0BAA0B;IACzC;AACJ;;;AAGA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;AAC1B","sourcesContent":[".contentContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    height: 100%;\n    width: 80%;\n    position: relative;\n    min-height: 600px;\n}\n\n.captionContainer {\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    gap: 8px;\n    position: absolute;\n    top: 25%;\n    width: 100%;\n    min-height: 150px;\n}\n\n.bottomWrapper {\n    justify-content: center;\n    margin-top: auto;\n    margin-bottom: calc(160px - 4vh);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.verificationContainer {\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    gap: 8px;\n    margin-bottom: 60px;\n}\n\n/* For smaller screens */\n@media (max-height: 800px) {\n    .bottomWrapper {\n        margin-bottom: calc(100px - 2vh);\n    }\n    .captionContainer {\n        top: 15%;  /* Bring it a bit higher */\n    }\n}\n\n\n.mainTitle {\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 32px;\n}\n\n.subTitle {\n    color: #424242;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n}\n\n.spacer {\n    height: 10px;\n}\n\n.description {\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n}\n\n.rightPanel {\n    display: flex;\n    flex-grow: 1;\n    align-items: center;\n    flex-direction: column;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentContainer": `SSIEmailVerificationPage_contentContainer__pi2VA`,
	"captionContainer": `SSIEmailVerificationPage_captionContainer__40XfX`,
	"bottomWrapper": `SSIEmailVerificationPage_bottomWrapper__61WBZ`,
	"verificationContainer": `SSIEmailVerificationPage_verificationContainer__sgGPG`,
	"mainTitle": `SSIEmailVerificationPage_mainTitle__kZU3C`,
	"subTitle": `SSIEmailVerificationPage_subTitle__O8ma7`,
	"spacer": `SSIEmailVerificationPage_spacer__vpHZT`,
	"description": `SSIEmailVerificationPage_description__7Yg4b`,
	"rightPanel": `SSIEmailVerificationPage_rightPanel__+0Y7i`
};
export default ___CSS_LOADER_EXPORT___;
